'use client';

import React, { useState } from 'react';
import Link from 'next/link';
import LoginWithOTP from './LoginWithOTP';
import LoginWithPass from './LoginWithPass';

const LoginForm = ({ redirect }: any) => {
  const [isPassword, setIsPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);

  return (
    <>
      {isPassword ? (
        <LoginWithPass rememberMe={rememberMe} redirect={redirect} />
      ) : (
        <LoginWithOTP redirect={redirect} />
      )}

      {/* --- New Login Options --- */}
      <div className="d-flex align-items-center my-4">
        <div className="flex-grow-1 border-top"></div>
        <span className="mx-3 text-muted small">OR</span>
        <div className="flex-grow-1 border-top"></div>
      </div>

      <button
        onClick={() => setIsPassword(!isPassword)}
        className="trk-btn trk-btn--primary d-block mt-3"
      >
        {isPassword ? 'Login With OTP' : 'Login With Password'}
      </button>

      <div className="account__check">
        <div className="account__check-remember">
          <input
            type="checkbox"
            className="form-check-input"
            id="terms-check"
            checked={rememberMe}
            onChange={(e) => setRememberMe(e.target.checked)}
          />
          <label htmlFor="terms-check" className="form-check-label">
            Remembered for 30 days
          </label>
        </div>
        <div className="account__check-forgot">
          <Link href="/forgot-password">Forgot Password?</Link>
        </div>
      </div>
    </>
  );
};

export default LoginForm;
